<!--
 * @Author: 仙道
 * @Date: 2022-04-19 22:18:36
 * @LastEditTime: 2022-12-04 16:38:50
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/views/equipment/account/modules/AccountDetail.vue
-->
<template>
  <page-layout :title="`设备名称：${deviceData.devName||'-'}`">
    <div class="page-header-content" slot="headerContent">
      <div class="avatar">
        <j-image-upload :disabled="true" bizPath="scott/pic" v-model="deviceData.pictureObjId"></j-image-upload>
      </div>
      <div class="content">
        <a-descriptions :column="4">
          <a-descriptions-item
            :key="index"
            :label="item.name"
            v-for="(item,index) in accountItemTab.filter(item=>!item.disabled)"
          >
            <template v-if="item.dict">{{ $filterDictTextByCache(item.dict,item.v) }}</template>
            <template v-else-if="item.k==='qrcode'">
              <div class="relative">
                <img :src="deviceData.qrcode" preview />
              </div>
            </template>
            <template v-else>{{ item.v }}</template>
          </a-descriptions-item>
        </a-descriptions>
      </div>
    </div>

    <div class="c-tabs">
      <a-card :bordered="false">
        <a-tabs v-if="tableLoading">
          <a-tab-pane :key="item.key" :tab="item.tab" v-for="(item) in componentList">
            <component :deviceData="deviceData" :is="item.views" :query="item.query||item.propsData" @ok="detailOk" />
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </div>
  </page-layout>
</template>

<script>
  import PageLayout from '@/components/page/PageLayout'

  import { mapGetters } from 'vuex'
  // import TopBaseInfo from './TopBaseInfo.vue'
  // import TopBaseInfoText from './TopBaseInfoText.vue'
  import DetailList from '@/components/tools/DetailList'
  // import { PageHeaderWrapper } from '@ant-design-vue/pro-layout'
  import { getAction } from '@/api/manage'

  const DetailListItem = DetailList.Item
  export default {
    name: 'AccountDetail',
    components: {
      // PageHeaderWrapper,
      PageLayout,
      DetailListItem,
      DetailList
    },
    // 定义属性
    data () {
      return {
        tableLoading: false,

        activeTabKey: '',
        contentWidth: 'Fluid',
        accountItemTab: [
          {
            name: '设备名称',
            k: 'devName',
            v: '',
            disabled: true
          },
          {
            name: '表号',
            k: 'devTag',
            v: ''
          },
          {
            name: '设备类型',
            k: 'typeName',
            v: ''
          },
          {
            name: '设备状态',
            k: 'serviceStatus',
            type: 'emnu',
            dict: 'dev_life_status'
          },
          //   {
          //     name: '供水流域',
          //     k: 'areaName',
          //     v: ''
          //   },
          {
            name: '供水流域',
            k: 'processName',
            v: ''
          },
          {
            name: '重要性',
            k: 'importance',
            v: '',
            type: 'emnu',
            dict: 'device_importance'
          },
          {
            name: '负责人',
            k: 'multiUser',
            v: ''
          },
          {
            name: '上级设备',
            k: 'parentName',
            v: ''
          },
          {
            name: '生产厂家',
            k: 'manuName',
            v: ''
          },
          {
            name: '设备型号',
            k: 'modelName',
            v: ''
          },
          {
            name: '出厂日期',
            k: 'factoryDate',
            v: ''
          },
          {
            name: '出厂编号',
            k: 'factoryNumber',
            v: ''
          },
          {
            name: '使用寿命',
            k: 'runningLife',
            v: ''
          },

          {
            name: '二维码',
            k: 'qrcode',
            v: ''
          }
        ],
        componentList: [
          {
            view: 'BaseInfo',
            name: '运行概况',
            path: 'equipment/account/modules/components/BaseInfo'

          },
          {
            view: 'AccountManual',
            name: '设备手册',
            path: 'equipment/account/modules/components/AccountManual'

          },
          {
            view: 'AccountParams',
            name: '设备参数',
            path: 'equipment/account/modules/components/AccountParams'

          },
          {
            view: 'MeasuringPoint',
            name: '相关测点',
            path: 'equipment/account/modules/components/MeasuringPoint'
          },
          {
            view: 'IotAlertListForPerson',
            name: '未处理告警',
            path: 'monitor/alert/IotAlertListForPerson'
          },

          // {
          //   view: 'Maintenance',
          //   name: '保养标准'
          // },
          {
            view: 'RecordInfo',
            name: '履历',
            path: 'equipment/account/modules/components/RecordInfo'

          }
          // 供水流域挂测点
          // 设备型号关联设备类型
          // 设备类型ui改造
        ],
        url: {
          // device/commonManufacturer/selectDropList
          commonManufacturer: '/device/commonManufacturer/selectDropList',
          queryById: '/device/devList/queryDetailById'
        },
        // 制造商
        manuList: [],
        deviceData: {}

      }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {
      ...mapGetters(['']),
      operationType () {
        return this.$route.query.pageType || 'form'
      },
      deviceId () {
        return this.$route.query.accountId || this.$route.query.deviceId
      }
    },
    // 监控data中的数据变化
    watch: {

    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created () {
      if (this.tableLoading) return
      this.InitData()
      this.Initialize()

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted () {

    },
    // 方法集合
    methods: {
      Initialize () {
        const tabs = this.componentList.reduce((arr, cur) => {
          const _cur = {
            propsData: {},
            deviceId: this.deviceId,
            tab: cur.name,
            key: cur.view,
            views: (resolve) => require([`@/views/${cur.path}.vue`], resolve)
          }
          if (cur.view == 'IotAlertListForPerson') {
            _cur.query = {
              devId: this.deviceId,
              disposal: 0
            }
          }
          arr.push(_cur)
          return arr
        }, [])
        this.componentList = tabs
      },

      async InitData () {
        const res = await getAction(this.url.queryById, { id: this.deviceId })
        this.deviceData = res.result
        const itemTab = this.accountItemTab.reduce((pre, cur) => {
          cur.v = res.result[cur.k]
          pre.push(cur)
          return pre
        }, [])
        //  this.accountItemTab = itemTab
        this.tableLoading = true
      },
      detailOk () {
        this.InitData()
      }
      // Initialize
    }
  }
</script>

<style lang='less' scoped>
  @import './index.less';

  .detail-layout {
    margin-left: 44px;
  }
  .text {
    color: rgba(0, 0, 0, 0.45);
  }
  .c-tabs {
    background: #fff;
    &-panel {
      min-height: 400px;
      &-head {
        font-size: 16px;
        font-weight: 700;
      }
    }
  }
  .device-img {
    width: 100px !important;
    height: 100px !important;
    border-radius: 0% !important;
  }
  ::v-deep {
    .content {
      position: relative;
      margin-top: 0px;
    }
    .page-header {
      border-bottom: none;
    }
    .term {
      vertical-align: top;
    }
    .ant-descriptions-row {
      .ant-descriptions-item-label {
        vertical-align: inherit;
      }
      .ant-descriptions-item-content {
        vertical-align: inherit;
      }
    }
    .ant-upload.ant-upload-select-picture-card {
      height: 100px;
      width: 100px;
    }
    img {
      height: 40px;
      width: 40px;
    }
  }
</style>
